import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["target"]

  place(event) {
    const value = event.params.target
    if (!value) return

    this.targetTarget.value = value
    this.element.requestSubmit()
  }

  closeAfterSubmit(event) {
    if (!event.detail.success) return

    this.element.closest("dialog")?.close()

    document.querySelectorAll('[data-controller~="dropdown-menu"]').forEach((element) => {
      const controller = this.application.getControllerForElementAndIdentifier(element, "dropdown-menu")
      controller?.forceHide(null)
    })
  }
}
